// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#page_error img[data-v-49e266f7]{width:60%;max-width:400px;margin:40px auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
